interface Row {
  label: string;
  text: string;
}

interface Props {
  rows: Row[];
}

/** A short note under an image upload: where the image appears in the app
 *  and which size works best. */
export const ImageUploadHint = ({ rows }: Props) => (
  <div className="-mt-2 mb-4 rounded border-l-4 border-primary-base bg-sky-lighter px-4 py-3 font-satoshi text-sm text-dark space-y-1">
    {rows.map((row) => (
      <p key={row.label}>
        <span className="font-bold">{row.label}:</span> {row.text}
      </p>
    ))}
  </div>
);

export const BANNER_IMAGE_HINT: Row[] = [
  {
    label: "Where",
    text: "The wide banner at the top of the challenge page in the app.",
  },
  {
    label: "Best size",
    text: "1200 x 500 px (wide, about 2.4 : 1), PNG or JPG.",
  },
  {
    label: "Tip",
    text: "Keep the logo and any text in the middle. Phones cut a little off the left and right.",
  },
];

export const CARD_IMAGE_HINT: Row[] = [
  {
    label: "Where",
    text: "The square box on the left of the challenge cards: Home, Play & Win, History and the drop receipt.",
  },
  {
    label: "Best size",
    text: "800 x 800 px (square), PNG or JPG.",
  },
  {
    label: "Tip",
    text: "Keep the logo inside the middle 80%. The edges can be cut a little.",
  },
  {
    label: "Optional",
    text: "Without a card image, the cards show the banner, cut to fit.",
  },
];
